__turbopack_context__.v({
  "downtimeAlert": "downtime-alert-module__OtSkrG__downtimeAlert",
  "downtimeAlertContainer": "downtime-alert-module__OtSkrG__downtimeAlertContainer",
});
